// State List Item Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'

class StateListItem extends Component {
  constructor (props) {
    super(props)

    this._references = {
      confirmDelete: React.createRef()
    }
  }

  static get propTypes () {
    return {
      title: PropTypes.string,
      onClick: PropTypes.func,
      onDelete: PropTypes.func,
      onDeleteConfirm: PropTypes.func,
      active: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      title: '',
      onClick: null,
      onDelete: null,
      onDeleteConfirm: null,
      active: false
    }
  }

  render () {
    const _className = classnames('state-list-item', {
      active: this.props.active
    })

    return (
      <div className={_className} onClick={this._onClickItem.bind(this)}>
        <div className='itemcont'>
          {this.props.title}
          <div
            className='form-input-delete'
            onClick={this._onDeleteItem.bind(this)}
          >
            <span className='icon icon-form-input-delete normal' />
            <span className='icon icon-form-input-delete-hover hover' />
          </div>
        </div>
        <ConfirmDelete
          ref={this._references.confirmDelete}
          title='setting.taxRate.msgConfirmDelete'
          onClickOk={this._onRemoveItem.bind(this)}
        />
      </div>
    )
  }

  hideConfirmDelete () {
    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.hide()
    }
  }

  _onClickItem (ev) {
    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.hide()
    }

    if (this.props.onClick) {
      this.props.onClick(ev)
    }
  }

  _onDeleteItem (ev) {
    ev.preventDefault()
    ev.stopPropagation()

    if (this.props.onDeleteConfirm) {
      if (this.props.onDelete) {
        this.props.onDelete()
      }

      if (this._references.confirmDelete.current) {
        this._references.confirmDelete.current.show()
      }
    }
  }

  _onRemoveItem () {
    if (this.props.onDeleteConfirm) {
      this.props.onDeleteConfirm()
    }
  }
}

export default StateListItem
